<template>
  <div class="bg-surface-default-mid py-8 pl-32">
    <BurgerMenuIcon
      class="mr-12"
      data-test="desktop-burger-menu"
      @burger-menu-clicked="emit('burger-menu-clicked')"
    />
    <div
      class="flex-1 items-center overflow-hidden whitespace-nowrap"
      data-test="topsalesbar"
    >
      <div class="flex items-center overflow-x-scroll scrollbar-none">
        <span
          v-for="(sale, index) in topSales"
          :key="sale.title_display"
          class="body-2 mr-24 first:pl-24 last:mr-56"
        >
          <RevLink
            :style="sale.style"
            :to="sale.link"
            :underlined="false"
            @click="trackHorizontalNav(sale, index)"
          >
            {{ sale.title }}
          </RevLink>
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { TopSale } from '@backmarket/http-api/src/api-specs-navigation-experience/navigation'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { isEmpty } from '@backmarket/utils/object/isEmpty'
import { RevLink } from '@ds/components/Link'

import { useTopSales } from '../composables/useTopSales'

import BurgerMenuIcon from './BurgerMenuIcon.vue'

const { trackClick } = useTracking()

const { data } = useTopSales()

const topSales = computed(() => {
  if (
    data.value === null ||
    data.value === undefined ||
    !Array.isArray(data.value)
  )
    return []

  return data.value
    .filter((sale) => sale.title && !isEmpty(sale.link))
    .map((sale) => ({
      ...sale,
      style: {
        ...sale.style,
        color: sale.style.text_color,
      },
    }))
})

function trackHorizontalNav(sale: TopSale, index: number) {
  trackClick({
    zone: 'header',
    name: `topsales-${index}-${sale.title}`,
  })
}
const emit = defineEmits(['burger-menu-clicked'])
</script>
